import { inject, observer } from 'mobx-react';
import React, { useState } from 'react';

import { IconButton } from '../../styled';
import { MuteIcon, SoundOnIcon } from './MuteButtonStyles';

const MuteButton = inject('chatStore')(
  observer((props: any) => {
    const [mute, setMute] = useState(false);
    const { chatStore } = props;

    const toggleSound = () => {
      setMute(!mute);
      chatStore.mute(!mute);
    };

    return <IconButton onClick={toggleSound}>{mute ? <MuteIcon /> : <SoundOnIcon />}</IconButton>;
  }),
);

export default MuteButton;
